import { Position } from './../../../app/models/api/vehicle-position.model';

class ArchiveRequestResponseData {
  code: string;
  request_id: string;
  archive_id: string;
  result: string;
  success: string;
  error: string;
}

class ArchiveDemandResponseData {
  code: string;
  request_id: string;
  id: string;
  filename: string;
  vehicle: string;
  success: string;
  error: string;
  position: ArchivePosition[] = [];
}
class VehiclesData {
  archive: ArchiveDemandResponseData;
}

class DisconnectData {
  code: string;
  response: string;
}

export interface ArchivePosition extends Position {
  tail: string;
  pin: string;
}

export interface ArchiveRequestResponse {
  requestarchive: ArchiveRequestResponseData;
}

export class ArchiveFrameset {
  frame: ArchiveDemandResponse[] = [];
}

export class ArchiveData {
  positionsWithoutStops: ArchivePosition[] = [];
  positionsWithStops: ArchivePosition[] = [];
  positions: ArchivePosition[] = [];
  ignoreStops: boolean = true;
  vehicleName: string;
  vehicleType: string;
  expanded: boolean = true;
  display: DisplayType = DisplayType.EVENT_DRIVEN;
  loading: boolean = true;
  color: string = '#000000';
  dateRange: number[] = [];
  isArchiveFromCSV: boolean;
  oneDataPerMin: boolean = false;
}

export interface ArchiveDemandResponse {
  vehicles_data: VehiclesData;
  disconnect: DisconnectData;
}

export interface ArchiveEtollFrame {
  time: number;
  latitude: number;
  longitude: number;
  satellites: number;
  distance: number;
  direction: number;
  gpsFix: boolean;
  speed: number;
  ignition: boolean;
  supply: number;
}
export interface ArchiveResponse {
  vehicleId: string;
  dateTimeFrom: Date;
  dateTimeTo: Date;
  userId: number;
  fleetId: number;
  createdAt: Date;
  extColumns: string[];
  entries: { [key: string]: any }[];
}

export interface ArchiveEvent {
  time: number;
  distance: number;
  duration: number;
  eventType: ArchiveEventType;
  start: boolean;
  location?: string;
  additionalData?: string;
}
export interface ArchiveEventDay {
  date: number;
  baseStats: ArchiveBaseStats;
  locationsEvents: ArchiveEventLocation[];
}

export interface ArchiveEventLocation {
  location: string;
  events: ArchiveEvent[];
}

export enum DisplayType {
  EVENT_DRIVEN,
  TABLE,
  STATISTICS,
}

export enum ArchiveEventType {
  PARKING = 'parking',
  RIDE = 'ride',
  BAKTIR1 = 'baktir1',
  BAKTIR2 = 'baktir2',
  TEMP1 = 'temp1',
  TEMP2 = 'temp2',
  TEMP3 = 'temp3',
  TEMP4 = 'temp4',
  TEMP5 = 'temp5',
  BORDER = 'border',
  ON_OFF = 'onOff',
  PRIVATE_RIDE = 'privateRide',
  DRIVER = 'driver',
}

export interface ArchiveBaseStats {
  fuelUsed: number;
  distance: number;
  totalDrivingTime: number;
  totalDistance: number;
}

export interface ArchiveStats extends ArchiveBaseStats {
  totalStopsTime: number;
  totalParkingTime: number;
  longestStopTime: number;
  engineStartsNumber: number;
  maxSpeed: number;
  avgSpeed: number;
  fuelUsedPer100km: number;
  maxEngineSpeed: number;
  avgEngineSpeed: number;
}
